module.exports = __webpack_public_path__ + "static/media/emma-watson-lose.28ff7378.jpg";